export class ElGuapoError extends Error {
  constructor(message) {
    super(message);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ElGuapoError);
    }

    this.name = "ElGuapoError";
  }
}
